(function () {
  const heros = [];
  const MIN_VISIBLE = 0.45;

  function isDesktop() {
    return window.matchMedia("(min-width: 990px)").matches;
  }

  function videoForSlide(slide) {
    if (!slide) return null;
    const desktop = slide.querySelector(".video-hero__video--desktop");
    const mobile = slide.querySelector(".video-hero__video--mobile");
    if (desktop && mobile) return isDesktop() ? desktop : mobile;
    return slide.querySelector("video");
  }

  function allPageVideos() {
    return Array.from(document.querySelectorAll("[data-video-hero] video"));
  }

  function pauseAllExcept(active) {
    allPageVideos().forEach(function (video) {
      if (video === active) return;
      video.pause();
    });
  }

  function mostVisibleHero() {
    let best = null;
    let bestRatio = MIN_VISIBLE;
    heros.forEach(function (hero) {
      if (hero.visibleRatio >= bestRatio) {
        bestRatio = hero.visibleRatio;
        best = hero;
      }
    });
    return best;
  }

  function syncPlayback() {
    const activeHero = mostVisibleHero();
    heros.forEach(function (hero) {
      if (hero === activeHero) hero.playActive();
      else hero.pauseActive();
    });
  }

  function initHero(root) {
    const slides = Array.from(root.querySelectorAll(".video-hero__frame"));
    const soundBtn = root.querySelector("[data-sound-toggle]");
    const gate = root.querySelector("[data-play-gate]");
    const wantSound = root.dataset.sound === "true";
    let index = 0;
    let soundOn = wantSound;

    if (!slides.length) return;

    function activeVideo() {
      return videoForSlide(slides[index]);
    }

    function attemptPlay(video) {
      if (!video) return Promise.resolve();
      pauseAllExcept(video);
      video.muted = !soundOn;
      const playPromise = video.play();
      if (!playPromise || typeof playPromise.then !== "function") return Promise.resolve();
      return playPromise.catch(function () {
        if (soundOn) {
          video.muted = true;
          soundOn = false;
          if (soundBtn) {
            soundBtn.setAttribute("aria-pressed", "false");
            soundBtn.setAttribute("aria-label", "Unmute video");
          }
          return video.play().then(function () {
            if (gate) gate.hidden = false;
          }).catch(function () {
            if (gate) gate.hidden = false;
          });
        }
        if (gate) gate.hidden = false;
      });
    }

    function playActive() {
      const video = activeVideo();
      if (!video) return;
      root.querySelectorAll("video").forEach(function (item) {
        if (item !== video) item.pause();
      });
      attemptPlay(video);
    }

    function pauseActive() {
      root.querySelectorAll("video").forEach(function (video) {
        video.pause();
      });
    }

    function playWithSound() {
      soundOn = true;
      if (soundBtn) {
        soundBtn.setAttribute("aria-pressed", "true");
        soundBtn.setAttribute("aria-label", "Mute video");
      }
      if (gate) gate.hidden = true;
      heros.forEach(function (hero) {
        hero.visibleRatio = hero === instance ? 1 : 0;
      });
      playActive();
    }

    if (soundBtn) {
      soundBtn.addEventListener("click", function () {
        soundOn = !soundOn;
        soundBtn.setAttribute("aria-pressed", soundOn ? "true" : "false");
        soundBtn.setAttribute("aria-label", soundOn ? "Mute video" : "Unmute video");
        const video = activeVideo();
        if (video) video.muted = !soundOn;
        if (soundOn) {
          heros.forEach(function (hero) {
            hero.visibleRatio = hero === instance ? 1 : 0;
          });
          playActive();
        }
      });
    }

    if (gate) gate.addEventListener("click", playWithSound);
    const watchBtn = root.querySelector("[data-watch-video]");
    if (watchBtn) watchBtn.addEventListener("click", playWithSound);

    const instance = {
      root: root,
      visibleRatio: 0,
      playActive: playActive,
      pauseActive: pauseActive
    };
    heros.push(instance);

    window.matchMedia("(min-width: 990px)").addEventListener("change", function () {
      pauseActive();
      syncPlayback();
    });
  }

  document.querySelectorAll("[data-video-hero]").forEach(initHero);

  if (!("IntersectionObserver" in window)) {
    if (heros[0]) {
      heros[0].visibleRatio = 1;
      syncPlayback();
    }
    return;
  }

  const observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      const hero = heros.find(function (item) { return item.root === entry.target; });
      if (hero) hero.visibleRatio = entry.intersectionRatio;
    });
    syncPlayback();
  }, {
    threshold: [0, 0.2, 0.35, 0.45, 0.6, 0.8, 1]
  });

  heros.forEach(function (hero) {
    observer.observe(hero.root);
  });

  document.addEventListener("visibilitychange", function () {
    if (document.hidden) {
      allPageVideos().forEach(function (video) { video.pause(); });
    } else {
      syncPlayback();
    }
  });
})();
